import * as React from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { CustomTextInput } from '../../../../components/commonComponents/TextInputs/style';
import { HtmlTooltip } from '../../../../components/commonComponents/StyledComponents/styled';
import { Box, Typography } from '@mui/material';
import { Info, InfoOutlined } from '@mui/icons-material';
import { fetchBrandUsers } from '../../../../api_calls/userManagement';
import { useDispatch, useSelector } from 'react-redux';
import { updateStateData } from '../../../../Store/actions';
import { toast } from 'react-toastify';

const EmailSelection = ({ fieldErrors }) => {
    const userStateDetails = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [selectedEmails, setSelectedEmails] = React.useState([]);

    let sharedUserListitems =
        typeof userStateDetails.shared_report_users_list !== "undefined" && userStateDetails.shared_report_users_list.length > 0 ? userStateDetails.shared_report_users_list.map(sharedUser => sharedUser.email) : [];

    const options = typeof userStateDetails.brand_user_list_options !== "undefined" ? userStateDetails.brand_user_list_options.map((option) => option.label).filter(optionLabel => !sharedUserListitems.includes(optionLabel)) : [];

    React.useEffect(() => {
        fetchBrandUsers();
    }, []);

    return typeof userStateDetails.brand_user_list_options !== "undefined" ? (
        <>
            <Autocomplete
                multiple
                id="tags-filled"
                fullWidth={true}
                options={options}
                noOptionsText="No matches found"
                filterOptions={(filterOptions, params) => {
                    // filterOptions property contains the options that match the input, so we start with finding options that match the input value
                    let filtered = filterOptions.filter(
                        (opt) =>
                            opt.toLowerCase().indexOf(params.inputValue.toLowerCase()) !== -1
                    );

                    // next, we check if the input value already exists in the options
                    const isExisting = options.some(
                        (opt) =>
                            opt.toLowerCase() === params.inputValue.trim().toLowerCase()
                    );

                    // if it does not exist, we add a new option to the filtered list
                    if (params.inputValue !== "" && !isExisting) {
                        // console.log("params.inputValue", params.inputValue);
                        // console.log("sharedUserListitems", sharedUserListitems);
                        if (sharedUserListitems.includes(params.inputValue)) {
                            filtered = [
                                `${params.inputValue}: (Already Shared)`,
                                ...filtered
                            ]
                        } else {
                            filtered = [
                                `New: ${params.inputValue}`,
                                ...filtered
                            ]
                        }

                    }

                    // exclude the values that are already selected
                    const finalFiltered = filtered.filter(
                        (opt) =>
                            !userStateDetails.selected_brand_userforReportshare ||
                            !userStateDetails.selected_brand_userforReportshare.includes(opt)
                    );
                    // filtered list doesn't change the original options, it is just used to display the dropdown
                    return finalFiltered;
                }}
                value={typeof userStateDetails.selected_brand_userforReportshare !== "undefined"
                    ? userStateDetails.selected_brand_userforReportshare
                    : []}
                freeSolo
                autoFocus={false}
                size="small"
                // disableCloseOnSelect
                onChange={(e, selectedOptions, action) => {
                    // disable selecting an email that is already shared
                    const lastSelectedValue = selectedOptions.length > 0 ? selectedOptions[selectedOptions.length - 1].replace("New: ", "") : "";
                    if (selectedOptions.join(",").includes(": (Already Shared)") || (lastSelectedValue && sharedUserListitems.includes(lastSelectedValue))) {
                        toast("This e-mail is already shared for this report.", { type: "error" });
                        return;
                    } else {
                        dispatchAction(updateStateData({
                            selected_brand_userforReportshare: action === "createOption" ? selectedOptions.map((value, index) => {
                                if (index === selectedOptions.length - 1) {
                                    return "New: " + value;
                                } else {
                                    return value;
                                }
                            }) : selectedOptions,
                            show_report_cancel_confirmation: true
                        }))
                        setSelectedEmails(selectedOptions);
                    }

                }}
                renderTags={(value, getItemProps) =>
                    value.map((option, index) => {
                        const { key, ...itemProps } = getItemProps({ index });
                       
                        return (
                            <Chip
                                variant="filled"
                                label={option}
                                key={key}
                                size='small'
                                sx={{
                                    backgroundColor: "#AF3241",
                                    color: "#FFFFFF",
                                    '& .MuiChip-deleteIcon': {
                                        color: "#FFFFFF",
                                    },
                                }}
                                {...itemProps} />
                        );
                    })
                }
                renderInput={(params) => (
                    <CustomTextInput
                        {...params}
                        autoFocus={false}
                        autoComplete="new-password"
                        name="shared_user_list"
                        type='text'
                        id={"cutomTextForEmailSelection"}
                        fullWidth={true}
                        label={<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            Enter Recipient(s)
                            <HtmlTooltip title={
                                <Box width={300}>
                                    <Typography variant="body2">
                                        Add an e-mail address by pressing the Return key or select one from your list of Favorites. You can add multiple e-mail addresses.
                                    </Typography>
                                    <Box height={10} />
                                    <Typography variant="body2">
                                        Brand accounts can be marked as favorites in the User Settings.
                                    </Typography>
                                </Box>
                            }>
                                <InfoOutlined
                                    // fontSize="small"
                                    sx={{ color: "#AF3241", cursor: "pointer", fontSize: "16px" }}
                                />
                            </HtmlTooltip>
                        </Box>}
                        variant="standard"
                        error={typeof fieldErrors !== "undefined" && typeof fieldErrors.email_list !== "undefined" ? true : false}
                        helperText={typeof fieldErrors !== "undefined" && typeof fieldErrors.email_list !== "undefined" ? fieldErrors.email_list : ""}
                    />
                )}
            />
            <Box height={15} />
            {
                [...userStateDetails.brand_user_list_options]
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map(userOption => {
                        if (userOption.fav === true && !sharedUserListitems.includes(userOption.label) && selectedEmails.includes(userOption.label) === false) {
                            return (<Chip
                                key={userOption.value}
                                label={userOption.label}
                                size='small'
                                variant='outlined'
                                onClick={() => {
                                    const updatedSelectedUsers = typeof userStateDetails.selected_brand_userforReportshare !== "undefined"
                                        ? [...userStateDetails.selected_brand_userforReportshare, userOption.label] : [userOption.label];
                                    dispatchAction(updateStateData({
                                        selected_brand_userforReportshare: updatedSelectedUsers,
                                    }));
                                    setSelectedEmails(updatedSelectedUsers);
                                }}
                                sx={{
                                    borderColor: "#AF3241",
                                    color: "#AF3241",
                                    marginRight: 1,
                                    cursor: "pointer",
                                    marginBottom: 1,
                                    '& .MuiChip-deleteIcon': {
                                        color: "#AF3241",
                                    },
                                }}
                            />)
                        }
                        return <></>;
                    })
            }
        </>
    ) : (<></>);
}

export default EmailSelection;
